import ItemDto from '../models/ItemDto';
import AllergenDto from '../models/AllergenDto';
import FoodTypeDto from '../models/FoodTypeDto';
import ItemLanguageDto from './language/item/ItemLanguageDto';
import ItemExtraDto from './ItemExtraDto';
import ItemOptionGroupDto from './ItemOptionGroupDto';
import { SelectedItemOptions } from '../components/dialogs/itemOptionsDialog/ItemOptionsDialog';

export default class CardItem extends ItemDto {
    quantity: number;
    selectedOptions: SelectedItemOptions;
    constructor(quantity: number, selectedOptions: SelectedItemOptions, id: number, price: number, allergens: AllergenDto[], foodTypes: FoodTypeDto[], imageUrl: string, symbolicImage: boolean, disabled: boolean, itemType: 'FOOD' | 'DRINK', itemExtras: ItemExtraDto[], itemOptionGroups: ItemOptionGroupDto[], value: ItemLanguageDto) {
        super(id, price, allergens, foodTypes, imageUrl, symbolicImage, disabled, itemType, itemExtras, itemOptionGroups, value);
        this.quantity = quantity;
        this.selectedOptions = selectedOptions;
    }
}